module.exports = __webpack_public_path__ + "static/media/fin_up2.bed8ab7d.png";